import React from 'react';

import { Button, Result } from 'antd';

import { FormattedMessage, useNavigate } from '@umijs/max';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      extra={(
        <Button onClick={() => { navigate('/'); }} type="primary">
          <FormattedMessage id="pages.403.buttonText" />
        </Button>
      )}
      status="403"
      subTitle={<FormattedMessage id="pages.403.subTitle" />}
      title="403"
    />
  );
};

export default Unauthorized;
